<mat-card class="add-personnel-card" data-cy="add-personnel-card">
  <mat-card-header>
    <div class="add-personnel-card-name">
      <span>{{ model.first }} {{ model.last }}</span>
    </div>
    <div class="add-personnel-checkboxes">
      <!-- <mat-checkbox
        class="is-business-checkbox"
        (change)="toggleIsBusiness()"
        [checked]="isBusiness">
        Is a Business
      </mat-checkbox> -->
    </div>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="form">
      <formly-form
        [form]="form"
        [fields]="fields"
        [model]="model"
        [options]="options">
      </formly-form>
    </form>
    <mat-checkbox
      data-cy="is-an-owner-checkbox"
      class="is-business-checkbox"
      (change)="toggleIsAnOwner()"
      [checked]="isAnOwner">
      Is an Owner
    </mat-checkbox>
  </mat-card-content>
  <mat-card-actions>
    <div class="add-personnel-buttons">
      <button
        *ngIf="form.dirty || !somethingIsSaving()"
        mat-button
        (click)="cancelEdit()"
        class="add-personnel-cancel-edit"
        [disabled]="somethingIsSaving()">
        Cancel
      </button>
      <button
        data-cy="create-button"
        mat-flat-button
        color="primary"
        (click)="save()"
        [disabled]="!form.dirty || !form.valid || somethingIsSaving()">
        <mat-spinner
          *ngIf="showSpinner()"
          diameter="24"
          class="add-personnel-spinny-spinner">
        </mat-spinner>
        <span>
          Create
        </span>
      </button>
    </div>
  </mat-card-actions>
  <div
    class="fake-signature-button"
    *ngIf="isAnOwner">
      Not Signed
      <button
        mat-button
        disabled="true">
          Send Marketplace Signature Request
      </button>
  </div>
</mat-card>
